import { BasePage } from '@Tenants/Jm/Site/BasePage';
import { BasePrivacy } from '@Base/Privacy/Privacy';

import "./Privacy.scss";

export class Privacy extends BasePrivacy
{
	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		

		super.Initialize();
	}
}

export class PrivacyPage extends BasePage
{
	public Privacy: Privacy;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.Privacy = new Privacy();
	}
}

const privacy = new PrivacyPage();